module.exports = __webpack_public_path__ + "img/Anhänger_I_2t.4e2a3dbc.svg";